<script setup>
const favoritesStore = useFavoritesStore()
favoritesStore.init()
const { item } = defineProps({
    item: Object
})

const isMobile = ref(false)

const checkMobile = () => {
    isMobile.value = window.innerWidth < 768 // 
}

onMounted(() => {
    checkMobile() // Проверка при загрузке
    window.addEventListener('resize', checkMobile) // Следим за изменением размера
})

onBeforeUnmount(() => {
    window.removeEventListener('resize', checkMobile) // Убираем слушатель
})

</script>
<template>
    <NuxtLink :to="`/build/${item.id}`" class="w-full h-full" :target="isMobile ? undefined : '_blank'">
        <div class="card rounded-xl hover:shadow-lg ease-in-out duration-300 overflow-hidden h-full flex flex-col">

            <div class="card__image relative h-[215px]">
                <div class="card_rate flex justify-between items-center absolute p-3 w-full z-[15]">
                    <div class="flex items-center gap-1">
                        <div v-if="item.class"
                            class="flex bg-gray-700 h-[22px] md:h-[26px] px-2 items-center justify-center rounded-md">
                            <p class="text-white text-[14px] md:font-normal p-0 ">{{ capitalize(item.class) }}</p>
                        </div>
                        <div v-if="item.offertype && item.offertype == 'prodaja'"
                            class="flex items-center justify-center bg-brand-green px-2 rounded-md h-[22px] md:h-[26px]">
                            <p class="text-white text-[14px] md:font-normal p-0 ">Продажа</p>
                        </div>
                        <div v-if="item.offertype && item.offertype == 'arenda'"
                            class="flex items-center justify-center bg-brand-primary px-2 rounded-md h-[22px] md:h-[26px]">
                            <p class="text-white text-[14px] md:font-normal p-0 ">Аренда</p>
                        </div>
                    </div>
                    <span>
                        <span v-if="!favoritesStore.is(item.id, 'offers')"
                            @click.prevent="favoritesStore.add(item.id, 'offers')"
                            class="cursor-pointer flex justify-center">
                            <img src="/img/icons/favorite_not_active.svg" alt="Избранное">
                        </span>
                        <span v-if="favoritesStore.is(item.id, 'offers')"
                            @click.prevent="favoritesStore.remove(item.id, 'offers')"
                            class="cursor-pointer flex justify-center">
                            <img src="/img/icons/favorite_active.svg" alt="Избранное">
                        </span>
                    </span>

                </div>

                <LayoutsPhotosHoverGalery v-model="item.photos" />

            </div>

            <div
                class="card__content bg-white p-3 border-b border-r border-l border-custom-gray rounded-b-xl md:border-none flex-grow">

                <p class="text-[#999] text-[8px] md:text-sm pb-2 md:font-medium " v-if="item.type_zdania">
                    {{ item.type_zdania }}
                </p>

                <h3 class="pb-1 text-sm md:text-lg font-normal text-gray-700">{{ item.header }}</h3>

                <p class="text-[#999] text-[8px] md:text-sm pb-2 md:font-medium " v-if="item.raion">
                    {{ item.raion || 'Не указан' }} район
                </p>

                <div class="flex items-center gap-2 pb-1" v-if="item.area">
                    <img src="/img/object.svg" alt="">
                    <p class="text-brand-blue text-xs md:text-sm md:font-semibold">{{ item.area }} кв.м.</p>
                </div>

                <div class="flex items-center gap-2 pb-1" v-else-if="item.area_build">
                    <img src="/img/object.svg" alt="">
                    <p class="text-brand-blue text-xs md:text-sm md:font-semibold">{{ item.area_build }} кв.м.</p>
                </div>

                <div class="flex gap-3 overflow-auto mt-3 mb-1 pb-1 z-40 flex-wrap custom-scroll">
                    <template v-for="child in item.children">
                        <div class="bg-gray-200 rounded-md p-2 min-w-[100px] w-auto">
                            <nuxt-link :to="`/offer/${child.id}`">
                                <p class="text-base">
                                    <span class="font-bold">{{ child.type }}</span>
                                    {{ child.area }} кв.м.
                                </p>
                            </nuxt-link>
                        </div>
                    </template>
                </div>

            </div>



        </div>
    </NuxtLink>
</template>

<style scoped>
.custom-scroll::-webkit-scrollbar {
    width: 3px;
    height: 5px;
    background-color: #f9f9fd;
}

.custom-scroll::-webkit-scrollbar-thumb {
    border-radius: 3px;
    background-color: #18aaaa65;
}

.custom-scroll::-webkit-scrollbar-track {
    border-radius: 3px;
    background-color: #f9f9fd;
}
</style>